import React, { useEffect, useState } from 'react';
import ServicePremimum from '../../components/ServicePremimum';
import ServicePlan from '../../components/ServicePlan';
import CoursesBanner from '../../components/CoursesBanner';
import CourseBannerAbout from '../../components/CourseBannerAbout';
import FeaturedCourses from '../../components/FeaturedCourses';
import CoursesLearningTools from '../../components/CoursesLearningTools';
import FAQSection from '../../components/FAQSection';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Courses = () => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("courses");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };
    fetchSeoData();
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          {seoData.metaTitle || "Courses | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Explore nutrition courses at Nutrillion"}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/courses"}
        />
      </Helmet>
      <CoursesBanner />
      <CourseBannerAbout />
      <FeaturedCourses />
      <CoursesLearningTools />
      <FAQSection />
    </div>
  );
};

export default Courses;